const { findPos } = require('../utils/PosUtil');

const prefixMatch = typeof window === 'object' && window.location && window.location.href
    ? window.location.href.match(/^https?:\/\/([a-z0-9]+)\./i) : null;
/**
* prefixMatch is either an array with both the whole
* string match and then the match group, or null
* Like:
* ['http://local.', 'local']
*/

// Default to www for prod if we can't figure out where we are
const haDomainHost = prefixMatch && prefixMatch.length === 2 ? prefixMatch[1] : 'www';
// Default to https for prod if we can't figure out where we are
const haProtocol = typeof window === 'object' && window.location ? window.location.protocol : 'https:';
const haDomainPrefix = `${haProtocol}//${haDomainHost}`;

export const haDomainMap = {
    vrbo: `${haDomainPrefix}.vrbo.com/`,
    haus: `${haDomainPrefix}.homeaway.com/`,
    hauk: `${haDomainPrefix}.homeaway.co.uk/`,
    hadk: `${haDomainPrefix}.homeaway.dk/`,
    hanl: `${haDomainPrefix}.homeaway.nl/`,
    abfr: `${haDomainPrefix}.abritel.fr/`,
    fdde: `${haDomainPrefix}.fewo-direkt.de/`,
    hait: `${haDomainPrefix}.homeaway.it/`,
    hano: `${haDomainPrefix}.homeaway.no/`,
    habr: `${haDomainPrefix}.aluguetemporada.com.br/`,
    hapt: `${haDomainPrefix}.homeaway.pt/`,
    haes: `${haDomainPrefix}.homeaway.es/`,
    hase: `${haDomainPrefix}.homeaway.se/`,
    haau: `${haDomainPrefix}.homeaway.com.au/`,
    hanz: `${haDomainPrefix}.homeaway.co.nz/`,
    hajp: `${haDomainPrefix}.homeaway.jp/`,
    haca: `${haDomainPrefix}.homeaway.ca/`,
    hacafr: `${haDomainPrefix}.vrbo.com/fr-ca/`,
    halk: `${haDomainPrefix}.homeaway.lk/`,
    hasg: `${haDomainPrefix}.homeaway.com.sg/`,
    havr: `${haDomainPrefix}.vacationrentals.com/`,
    haat: `${haDomainPrefix}.homeaway.at/`,
    hdfr: `${haDomainPrefix}.homelidays.com/`,
    default: `${haDomainPrefix}.vrbo.com/`
};

const haPaths = {
    LYP: 'lyp',
    PM: {
        vrbo: 'l/property-managers',
        haus: 'l/property-managers',
        hauk: 'l/property-managers',
        hadk: 'l/udlejningsagenturer',
        hanl: 'l/professionele-verhuurder',
        abfr: 'l/agences-immobilieres',
        fdde: 'l/agenturen',
        hait: 'l/professionisti-immobiliari',
        hano: 'l/utleieagenturer',
        hapt: 'l/gestores-de-imoveis',
        haes: 'l/profesionales-inmobiliarios',
        habr: 'l/administradores-profissionais',
        hajp: 'l/property-managers',
        hase: 'l/fastighetsforvaltare',
        haau: 'l/property-managers',
        halk: 'l/property-managers',
        hanz: 'l/property-managers',
        hasg: 'l/property-managers',
        havr: 'l/property-managers',
        haat: 'l/agenturen',
        hdfr: 'l/agences-immobilieres'
    },
    QC: 'p/onboard'
};

const getHaLink = (key, path, domainMap) => ((key && path && domainMap[key])
    ? `${domainMap[key]}${path}` : `${domainMap.default}${path}`);

const removeProtocol = (key, domainMap) => ((key && domainMap[key])
    ? `${domainMap[key].substring(haDomainPrefix.length + 1, domainMap[key].length - 1)}` : 'vrbo.com');

export const pageLocales = {
    en_US: {
        joinLangPath: 'en',
        haDomain: removeProtocol('vrbo', haDomainMap),
        haLink: getHaLink('vrbo', haPaths.LYP, haDomainMap),
        haPmLink: getHaLink('vrbo', haPaths.PM.vrbo, haDomainMap),
        haQcLink: getHaLink('vrbo', haPaths.QC, haDomainMap),
        haOwnerLoginPath: 'vrbo',
        hasHalfBath: true
    },
    en_CA: {
        joinLangPath: 'en',
        haDomain: removeProtocol('vrbo', haDomainMap),
        haLink: getHaLink('vrbo', haPaths.LYP, haDomainMap),
        haPmLink: getHaLink('vrbo', haPaths.PM.vrbo, haDomainMap),
        haOwnerLoginPath: 'vrbo',
        hasHalfBath: true
    },
    en_AU: {
        joinLangPath: 'en',
        haDomain: removeProtocol('haau', haDomainMap),
        haLink: getHaLink('haau', haPaths.LYP, haDomainMap),
        haPmLink: getHaLink('haau', haPaths.PM.haau, haDomainMap),
        haQcLink: getHaLink('haau', haPaths.QC, haDomainMap),
        haOwnerLoginPath: 'vrbo',
        hasHalfBath: true
    },
    en_NZ: {
        joinLangPath: 'en',
        haDomain: removeProtocol('hanz', haDomainMap),
        haLink: getHaLink('hanz', haPaths.LYP, haDomainMap),
        haPmLink: getHaLink('hanz', haPaths.PM.haau, haDomainMap),
        haQcLink: getHaLink('hanz', haPaths.QC, haDomainMap),
        haOwnerLoginPath: 'vrbo',
        hasHalfBath: true
    },
    en_LK: {
        joinLangPath: 'en',
        haDomain: removeProtocol('halk', haDomainMap),
        haLink: getHaLink('halk', haPaths.LYP, haDomainMap),
        haPmLink: getHaLink('halk', haPaths.PM.haau, haDomainMap),
        haQcLink: getHaLink('halk', haPaths.QC, haDomainMap),
        haOwnerLoginPath: 'vrbo',
        hasHalfBath: false
    },
    es_ES: {
        joinLangPath: 'es',
        haDomain: removeProtocol('haes', haDomainMap),
        haLink: getHaLink('haes', haPaths.LYP, haDomainMap),
        haPmLink: getHaLink('haes', haPaths.PM.haes, haDomainMap),
        haQcLink: getHaLink('haes', haPaths.QC, haDomainMap),
        haOwnerLoginPath: 'haes',
        hasHalfBath: false
    },
    it_IT: {
        joinLangPath: 'it',
        haDomain: removeProtocol('hait', haDomainMap),
        haLink: getHaLink('hait', haPaths.LYP, haDomainMap),
        haPmLink: getHaLink('hait', haPaths.PM.hait, haDomainMap),
        haQcLink: getHaLink('hait', haPaths.QC, haDomainMap),
        haOwnerLoginPath: 'hait',
        hasHalfBath: false
    },
    fr_FR: {
        joinLangPath: 'fr',
        haDomain: removeProtocol('abfr', haDomainMap),
        haLink: getHaLink('abfr', haPaths.LYP, haDomainMap),
        haPmLink: getHaLink('abfr', haPaths.PM.abfr, haDomainMap),
        haQcLink: getHaLink('abfr', haPaths.QC, haDomainMap),
        hasHalfBath: false
    },
    de_DE: {
        joinLangPath: 'de',
        haDomain: removeProtocol('fdde', haDomainMap),
        haLink: getHaLink('fede', haPaths.LYP, haDomainMap),
        haPmLink: getHaLink('fdde', haPaths.PM.fdde, haDomainMap),
        haQcLink: getHaLink('fdde', haPaths.QC, haDomainMap),
        haOwnerLoginPath: 'fewo',
        hasHalfBath: true
    },
    ru_RU: {
        joinLangPath: 'ru',
        haDomain: removeProtocol('hauk', haDomainMap),
        haLink: getHaLink('hauk', haPaths.LYP, haDomainMap),
        haPmLink: getHaLink('hauk', haPaths.PM.hauk, haDomainMap),
        haOwnerLoginPath: 'hr',
        hasHalfBath: false
    },
    pt_BR: {
        joinLangPath: 'pt-br',
        haDomain: removeProtocol('habr', haDomainMap),
        haLink: getHaLink('habr', haPaths.LYP, haDomainMap),
        haPmLink: getHaLink('habr', haPaths.PM.habr, haDomainMap),
        haOwnerLoginPath: 'habr',
        hasHalfBath: true
    },
    ja_JP: {
        joinLangPath: 'ja',
        haDomain: removeProtocol('hajp', haDomainMap),
        haLink: getHaLink('hajp', haPaths.LYP, haDomainMap),
        haPmLink: getHaLink('hajp', haPaths.PM.hajp, haDomainMap),
        haOwnerLoginPath: 'hajp',
        hasHalfBath: true
    },
    ko_KR: {
        joinLangPath: 'ko',
        haDomain: removeProtocol('vrbo', haDomainMap),
        haLink: getHaLink('vrbo', haPaths.LYP, haDomainMap),
        haPmLink: getHaLink('vrbo', haPaths.PM.vrbo, haDomainMap),
        haOwnerLoginPath: 'vrbo',
        hasHalfBath: true
    },
    vi_VN: {
        joinLangPath: 'vi',
        haDomain: removeProtocol('vrbo', haDomainMap),
        haLink: getHaLink('vrbo', haPaths.LYP, haDomainMap),
        haPmLink: getHaLink('vrbo', haPaths.PM.vrbo, haDomainMap),
        haOwnerLoginPath: 'vrbo',
        hasHalfBath: true
    },
    zh_CN: {
        joinLangPath: 'zh-cn',
        haDomain: removeProtocol('vrbo', haDomainMap),
        haLink: getHaLink('vrbo', haPaths.LYP, haDomainMap),
        haPmLink: getHaLink('vrbo', haPaths.PM.vrbo, haDomainMap),
        haOwnerLoginPath: 'vrbo',
        hasHalfBath: true
    },
    zh_TW: {
        joinLangPath: 'zh-tw',
        haDomain: removeProtocol('vrbo', haDomainMap),
        haLink: getHaLink('vrbo', haPaths.LYP, haDomainMap),
        haPmLink: getHaLink('vrbo', haPaths.PM.vrbo, haDomainMap),
        haOwnerLoginPath: 'vrbo',
        hasHalfBath: true
    },
    tr_TR: {
        joinLangPath: 'tr',
        haDomain: removeProtocol('hauk', haDomainMap),
        haLink: getHaLink('hauk', haPaths.LYP, haDomainMap),
        haPmLink: getHaLink('hauk', haPaths.PM.hauk, haDomainMap),
        haOwnerLoginPath: 'hr',
        hasHalfBath: false
    },
    nl_NL: {
        joinLangPath: 'nl',
        haDomain: removeProtocol('hanl', haDomainMap),
        haLink: getHaLink('hanl', haPaths.LYP, haDomainMap),
        haPmLink: getHaLink('hanl', haPaths.PM.hanl, haDomainMap),
        haOwnerLoginPath: 'hanl',
        hasHalfBath: false
    },
    th_TH: {
        joinLangPath: 'th',
        haDomain: removeProtocol('vrbo', haDomainMap),
        haLink: getHaLink('vrbo', haPaths.LYP, haDomainMap),
        haPmLink: getHaLink('vrbo', haPaths.PM.vrbo, haDomainMap),
        haOwnerLoginPath: 'vrbo',
        hasHalfBath: true
    },
    el_GR: {
        joinLangPath: 'el',
        haDomain: removeProtocol('hauk', haDomainMap),
        haLink: getHaLink('hauk', haPaths.LYP, haDomainMap),
        haPmLink: getHaLink('hauk', haPaths.PM.hauk, haDomainMap),
        haOwnerLoginPath: 'hr',
        hasHalfBath: false
    },
    pt_PT: {
        joinLangPath: 'pt-pt',
        haDomain: removeProtocol('hapt', haDomainMap),
        haLink: getHaLink('hapt', haPaths.LYP, haDomainMap),
        haPmLink: getHaLink('hapt', haPaths.PM.hapt, haDomainMap),
        haQcLink: getHaLink('hapt', haPaths.QC, haDomainMap),
        haOwnerLoginPath: 'hapt',
        hasHalfBath: false
    },
    en_GB: {
        joinLangPath: 'en',
        haDomain: removeProtocol('hauk', haDomainMap),
        haLink: getHaLink('hauk', haPaths.LYP, haDomainMap),
        haPmLink: getHaLink('hauk', haPaths.PM.hauk, haDomainMap),
        haQcLink: getHaLink('hauk', haPaths.QC, haDomainMap),
        haOwnerLoginPath: 'hr',
        hasHalfBath: false
    },
    sv_SE: {
        joinLangPath: 'sv',
        haDomain: removeProtocol('hase', haDomainMap),
        haLink: getHaLink('hase', haPaths.LYP, haDomainMap),
        haPmLink: getHaLink('hase', haPaths.PM.hase, haDomainMap),
        haOwnerLoginPath: 'hase',
        hasHalfBath: false
    },
    pl_PL: {
        joinLangPath: 'pl',
        haDomain: removeProtocol('hauk', haDomainMap),
        haLink: getHaLink('hauk', haPaths.LYP, haDomainMap),
        haPmLink: getHaLink('hauk', haPaths.PM.hauk, haDomainMap),
        haOwnerLoginPath: 'hr',
        hasHalfBath: false
    },
    nb_NO: {
        joinLangPath: 'no',
        haDomain: removeProtocol('hano', haDomainMap),
        haLink: getHaLink('hano', haPaths.LYP, haDomainMap),
        haPmLink: getHaLink('hano', haPaths.PM.hano, haDomainMap),
        haOwnerLoginPath: 'hano',
        hasHalfBath: false
    },
    hr_HR: {
        joinLangPath: 'hr',
        haDomain: removeProtocol('hauk', haDomainMap),
        haLink: getHaLink('hauk', haPaths.LYP, haDomainMap),
        haPmLink: getHaLink('hauk', haPaths.PM.hauk, haDomainMap),
        haOwnerLoginPath: 'hr',
        hasHalfBath: false
    },
    da_DK: {
        joinLangPath: 'da',
        haDomain: removeProtocol('hadk', haDomainMap),
        haLink: getHaLink('hadk', haPaths.LYP, haDomainMap),
        haPmLink: getHaLink('hadk', haPaths.PM.hadk, haDomainMap),
        haOwnerLoginPath: 'hadk',
        hasHalfBath: false
    },
    cs_CZ: {
        joinLangPath: 'cs',
        haDomain: removeProtocol('hauk', haDomainMap),
        haLink: getHaLink('hauk', haPaths.LYP, haDomainMap),
        haPmLink: getHaLink('hauk', haPaths.PM.hauk, haDomainMap),
        haOwnerLoginPath: 'hr',
        hasHalfBath: false
    },
    fi_FI: {
        joinLangPath: 'fi',
        haDomain: removeProtocol('hauk', haDomainMap),
        haLink: getHaLink('hauk', haPaths.LYP, haDomainMap),
        haPmLink: getHaLink('hauk', haPaths.PM.hauk, haDomainMap),
        haOwnerLoginPath: 'hr',
        hasHalfBath: false
    },
    hu_HU: {
        joinLangPath: 'hu',
        haDomain: removeProtocol('vrbo', haDomainMap),
        haLink: getHaLink('vrbo', haPaths.LYP, haDomainMap),
        haPmLink: getHaLink('vrbo', haPaths.PM.vrbo, haDomainMap),
        haOwnerLoginPath: 'vrbo',
        hasHalfBath: true
    },
    id_ID: {
        joinLangPath: 'id',
        haDomain: removeProtocol('vrbo', haDomainMap),
        haLink: getHaLink('vrbo', haPaths.LYP, haDomainMap),
        haPmLink: getHaLink('vrbo', haPaths.PM.vrbo, haDomainMap),
        haOwnerLoginPath: 'vrbo',
        hasHalfBath: true
    },
    ar_SA: {
        joinLangPath: 'en',
        haDomain: removeProtocol('vrbo', haDomainMap),
        haLink: getHaLink('vrbo', haPaths.LYP, haDomainMap),
        haPmLink: getHaLink('vrbo', haPaths.PM.vrbo, haDomainMap),
        haOwnerLoginPath: 'vrbo',
        hasHalfBath: true
    },
    he_IL: {
        joinLangPath: 'en',
        haDomain: removeProtocol('vrbo', haDomainMap),
        haLink: getHaLink('vrbo', haPaths.LYP, haDomainMap),
        haPmLink: getHaLink('vrbo', haPaths.PM.vrbo, haDomainMap),
        haOwnerLoginPath: 'vrbo',
        hasHalfBath: true
    },
    es_XL: {
        joinLangPath: 'es',
        haDomain: removeProtocol('vrbo', haDomainMap),
        haLink: getHaLink('vrbo', haPaths.LYP, haDomainMap),
        haPmLink: getHaLink('vrbo', haPaths.PM.vrbo, haDomainMap),
        haOwnerLoginPath: 'vrbo',
        hasHalfBath: true
    },
    zn_HK: {
        joinLangPath: 'en',
        haDomain: removeProtocol('vrbo', haDomainMap),
        haLink: getHaLink('vrbo', haPaths.LYP, haDomainMap),
        haPmLink: getHaLink('vrbo', haPaths.PM.vrbo, haDomainMap),
        haOwnerLoginPath: 'vrbo',
        hasHalfBath: true
    },
    is_IS: {
        joinLangPath: 'en',
        haDomain: removeProtocol('vrbo', haDomainMap),
        haLink: getHaLink('vrbo', haPaths.LYP, haDomainMap),
        haPmLink: getHaLink('vrbo', haPaths.PM.vrbo, haDomainMap),
        haOwnerLoginPath: 'vrbo',
        hasHalfBath: true
    },
    he_HE: {
        joinLangPath: 'he',
        haDomain: removeProtocol('vrbo', haDomainMap),
        haLink: getHaLink('vrbo', haPaths.LYP, haDomainMap),
        haPmLink: getHaLink('vrbo', haPaths.PM.vrbo, haDomainMap),
        haOwnerLoginPath: 'vrbo',
        hasHalfBath: true
    },
    fr_CA: {
        joinLangPath: 'fr',
        haDomain: removeProtocol('hacafr', haDomainMap),
        haLink: getHaLink('hacafr', haPaths.LYP, haDomainMap),
        haPmLink: getHaLink('abfr', haPaths.PM.vrbo, haDomainMap),
        haOwnerLoginPath: 'vrbo',
        hasHalfBath: false
    },
    ms_MY: {
        joinLangPath: 'en',
        haDomain: removeProtocol('vrbo', haDomainMap),
        haLink: getHaLink('vrbo', haPaths.LYP, haDomainMap),
        haPmLink: getHaLink('vrbo', haPaths.PM.vrbo, haDomainMap),
        haOwnerLoginPath: 'vrbo',
        hasHalfBath: true
    },
    bg_BG: {
        joinLangPath: 'en',
        haDomain: removeProtocol('vrbo', haDomainMap),
        haLink: getHaLink('vrbo', haPaths.LYP, haDomainMap),
        haPmLink: getHaLink('vrbo', haPaths.PM.vrbo, haDomainMap),
        haOwnerLoginPath: 'vrbo',
        hasHalfBath: true
    }
};

export const siteMap = {
    homeaway_au: {
        ...pageLocales.en_AU
    },
    homeaway_ca: {
        ...pageLocales.en_CA
    },
    homeaway_us: {
        joinLangPath: 'en',
        haDomain: removeProtocol('haus', haDomainMap),
        haLink: getHaLink('haus', haPaths.LYP, haDomainMap),
        haPmLink: getHaLink('haus', haPaths.PM.hauk, haDomainMap),
        haOwnerLoginPath: 'homeaway',
        hasHalfBath: true
    },
    homeaway_lk: {
        ...pageLocales.en_LK
    },
    homeaway_nz: {
        ...pageLocales.en_NZ
    },
    homeaway_sg: {
        joinLangPath: 'en',
        haDomain: removeProtocol('hasg', haDomainMap),
        haLink: getHaLink('hasg', haPaths.LYP, haDomainMap),
        haPmLink: getHaLink('hasg', haPaths.PM.hauk, haDomainMap),
        haOwnerLoginPath: 'vrbo',
        hasHalfBath: true
    },
    vr: {
        joinLangPath: 'en',
        haDomain: removeProtocol('havr', haDomainMap),
        haLink: getHaLink('havr', haPaths.LYP, haDomainMap),
        haPmLink: getHaLink('haus', haPaths.PM.havr, haDomainMap),
        haOwnerLoginPath: 'vr',
        hasHalfBath: true
    },
    homeaway_at: {
        joinLangPath: 'de',
        haDomain: removeProtocol('haat', haDomainMap),
        haLink: getHaLink('haat', haPaths.LYP, haDomainMap),
        haPmLink: getHaLink('haat', haPaths.PM.haat, haDomainMap),
        haOwnerLoginPath: 'haat',
        hasHalfBath: false
    },
    homelidays_fr: {
        joinLangPath: 'fr',
        haDomain: removeProtocol('hdfr', haDomainMap),
        haLink: getHaLink('hdfr', haPaths.LYP, haDomainMap),
        haPmLink: getHaLink('abfr', haPaths.PM.hdfr, haDomainMap),
        haOwnerLoginPath: 'hdfr',
        hasHalfBath: false
    }
};

export const getLinks = (locale, siteName) => siteMap[siteName] || pageLocales[locale];

export const getHostDetails = (vrboLocale) => {
    const domainName = typeof window === 'object' && window.location && window.location.href
        ? window.location.href.match(/^https?:\/\/([a-z0-9]+)\./i) : null;

    const isStage = domainName
        && (
            domainName.input.includes('lisqa7')
            || domainName.input.includes('stage')
            || domainName.input.includes('integration')
        );
    if (vrboLocale === 'de-de') {
        let modifiedHost = 'www.fewo-direkt.de';
        if (domainName && domainName[1] === 'local') {
            modifiedHost = 'local.fewo-direkt.de:8080';
        } else if (isStage) {
            modifiedHost = 'stage.fewo-direkt.de';
        }
        return modifiedHost;
    }
    if (vrboLocale === 'fr-fr') {
        let modifiedHost = 'www.abritel.fr';
        if (domainName && domainName[1] === 'local') {
            modifiedHost = 'local.abritel.fr:8080';
        } else if (isStage) {
            modifiedHost = 'stage.abritel.fr';
        }
        return modifiedHost;
    }

    let modifiedHost = 'www.vrbo.com';
    if (domainName && domainName[1] === 'local') {
        modifiedHost = 'local.vrbo.com:8080';
    } else if (isStage) {
        modifiedHost = 'stage.vrbo.com';
    }
    return modifiedHost;
};

export const getLocale = (urlParams, locale = '') => {
    const siteid = urlParams.get('siteId');
    const tpid = urlParams.get('tpid');
    const eapid = urlParams.get('eapid');
    const langid = urlParams.get('langId');
    const utmSource = urlParams.get('utm_source');
    const pos = findPos({
        tpid, eapid, siteid, langid, utmSource
    }, locale);
    return pos.localeVR;
};

export const getAdditionalLocales = (siteId, tpid, eapid, langId, utmSource, locale) => {
    const siteid = siteId;
    const langid = langId;

    const pos = findPos({
        tpid, eapid, siteid, langid, utmSource
    }, locale);
    return pos.additionalLocales;
};


export default {
    pageLocales,
    siteMap,
    getLinks,
    getHostDetails,
    getLocale,
    getAdditionalLocales
};
